export default "__VITE_ASSET__rk5UbAnw__"